import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import EstateProjectList from '@/modules/estate-project/views/estate-project-list.vue'
import EstateProjectCreate from '@/modules/estate-project/views/estate-project-create.vue'
import EstateProjectDetail from '@/modules/estate-project/views/estate-project-detail.vue'

const baseRoute = OneNetworkConfig.baseRoutePath

const estateProjectRouter = [
  {
    path: `${baseRoute}/property/projects`,
    name: 'property-projects',
    meta: {
      component: EstateProjectList,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/property/projects/create`,
    name: 'property-projects-create',
    meta: {
      component: EstateProjectCreate,
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/property/projects/:id`,
    name: 'property-projects-detail',
    meta: {
      component: EstateProjectDetail,
    },
    component: PrivateRouter,
  },
]

export default estateProjectRouter
